import React, {useEffect, useRef, useState, useContext} from "react";
import styles from "./createAnalysis/CreateAnalysis.module.scss";
import ModalBox from "../../../Componnets/ModalBox/ModalBox";
import Button from "../../../Componnets/Button/Button";
import appContext from "../../../../context/appContext";
import Toast from "../../../Componnets/EsmManagement/toast/Toast";
import http from "../../../../services/api/utilities/http";

const CreateAnalysis = ({ selectedWorkspaceId, handleShowCreateAnalysisModal, showModal, handleAddItemToAnalysisData, type, editData, handleRetrySaveAnalysisData, retrySaveAnalysis }) => {

    const name = useRef();
    const description = useRef();

    const [responseStatus, setResponseStatus] = useState(null);
    const [data, setData] = useState({
        name: null,
        description: null
    });
    const [showToast, setShowToast] = useState(false);

    const context = useContext(appContext);

    useEffect(() => {
        if (type === 'edit') {
            setData({ name: editData.name, description: editData.description });
        }
    }, [type]);

    useEffect(() => {
        context.handleSaveAnalysisStatus(responseStatus);
    }, [responseStatus])

    const analysisData = context.handleAnalysis();

    const postData = () => {

        let method = "post";
        let url = "data_connector/analysis/";
        if (type === "edit") {
            method = "patch";
            url = `data_connector/analysis/${editData.id}/`
        }
        setResponseStatus('fetching');

        let newItemToAdd = {};
        let newData = [];
        const hasErrorAnalysisData = analysisData.find(item => item.status === "error");

        if (hasErrorAnalysisData) {
            const newDataToSend = analysisData.filter(item => item.status !== "error");
            newItemToAdd = {
                name: hasErrorAnalysisData.name,
                description: hasErrorAnalysisData.description,
                workspace: selectedWorkspaceId,
            }
            newData = [...newDataToSend, {
                ...newItemToAdd,
                status: 'loading'
            }];
        } else {
            newItemToAdd = {
                name: data.name,
                description: data.description,
                workspace: selectedWorkspaceId,
            }
            newData = [{
                ...newItemToAdd,
                status: 'loading'
            }, ...analysisData];
        }
        context.handleAnalysis(newData);
        http[method](url,
            newItemToAdd)
            .then(res => {
                if (type === "addNew") {
                    const notIncludedStillLoadingData = newData.filter(item => {
                        if (!item.status || item.status !== 'loading') {
                            return item;
                        }
                    });
                    context.handleAnalysis([res.data.data, ...notIncludedStillLoadingData]);
                    handleAddItemToAnalysisData(res.data.data);
                    // context.handleSelectedWorkspaceInfo({id: res.data.data.id, name: res.data.data.name});
                } else if (type === "edit") {
                    const editedAnalysisData = context.handleAnalysis().map(item => {
                        if (item.id === editData.id) {
                            return res.data.data;
                        }
                        return item;
                    })
                    const newWorkspaceData = context.handleWorkspace().map(item => {
                        if (item.id === editData.workspace) {
                            const d = context.handleAnalysis().map(i => {
                                if (i.id === editData.id) {
                                    return res.data.data
                                }
                                return i
                            })
                            return {...item, analyses: d}
                        }
                        return item;
                    });
                    context.handleWorkspace(newWorkspaceData);
                    context.handleAnalysis(editedAnalysisData);
                }
                setResponseStatus('success');
                setShowToast(false);
            })
            .catch(err => {
                let newItemToAdd = {};
                const hasErrorAnalysisData = analysisData.find(item => item.status === "error");
                const notIncludedStillLoadingData = analysisData.filter(item => {
                    if (!item.status || (item.status !== 'loading')) {
                        return item;
                    }
                });
                if (hasErrorAnalysisData) {
                    const newDataToSend = analysisData.filter(item => item.status !== "error");
                    newItemToAdd = {
                        name: hasErrorAnalysisData.name,
                        description: hasErrorAnalysisData.description,
                        status: 'error'
                    };
                    newData = [...newDataToSend, newItemToAdd];
                } else {
                    newItemToAdd = {
                        name: data.name,
                        description: data.description,
                        status: 'error'
                    };
                    newData = [...notIncludedStillLoadingData, newItemToAdd];
                }
                setData({
                    name: newItemToAdd.name,
                    description: newItemToAdd.description,
                });
                context.handleAnalysis(newData);
                setResponseStatus("error");
                setShowToast(true);
                console.log(err.response);
            })
    }

    const handlePostAnalysisData = () => {
        handleShowCreateAnalysisModal();
        postData();
    }

    useEffect(() => {
        if (!showModal) {
            if (name.current) {
                name.current.value = '';
            }
            if (description.current) {
                description.current.value = '';
            }
            setData({
                name: null,
                description: null
            })
        }
    }, [showModal]);

    useEffect(() => {
        if (retrySaveAnalysis) {
            postData();
        }
        handleRetrySaveAnalysisData(false);
    }, [retrySaveAnalysis]);

    return (
        <div className={styles.CreateAnalysis}>
            <ModalBox
                title={type === 'addNew' ? 'New Analysis' : 'Edit Analysis'}
                size={'xxl'}
                showModal={showModal}
                handleTriggerShowModal={handleShowCreateAnalysisModal}
            >
                <div className={'container-fluid p-0 mt-3'}>
                    <div className={'row'}>
                        <div className={'col-sm-12'}>
                            <label>Analysis Name</label>
                            <input ref={name} value={data.name} onChange={(e) => setData({...data, name: e.target.value})} placeholder={'Select a name for your workspace'} />
                        </div>
                        <div className={'col-sm-12 mt-4'}>
                            <label>Analysis Description</label>
                            <textarea value={data.description} ref={description} onChange={(e) => setData({...data, description: e.target.value})} placeholder={'(Optional)'}></textarea>
                        </div>
                        <div className={'col-sm-12 mt-5 text-center'}>
                            <Button
                                onClick={handlePostAnalysisData}
                                type={'primary'}
                                size={'xLarge'}
                                title={responseStatus !== 'fetching' ? (type === 'addNew' ? 'Create Analysis' : 'Edit Analysis') : 'Please Wait'}
                                disabled={responseStatus === 'fetching'}
                            />
                        </div>
                    </div>
                </div>
            </ModalBox>
            {
                <Toast title={"Couldn't Create Analysis"} errorCode={"404"} show={showToast}>
                    We couldn't connect to server. Check your internet connection or try again later.
                </Toast>
            }
        </div>
    )
}

export default CreateAnalysis;